/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, { useState, useEffect, useCallback } from "react";
import "./../../../assets/css/purchase/form.css";
import DeliveryModalS from "../../components/Modal/DeliverymodalSearch";
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import {
  getAlert,
  getDataWithComp,
  getDataWithJoin,
  getSoWithoutPK,
} from "../../../utils/SamuiUtils";
import DatePicker from "../../components/DatePicker";
import { formatCurrency } from "../../../utils/SamuiUtils"; // Added for formatting NetTotal in summary row

const ReceivablesReport = () => {
  // ตัวแปรเก็บชื่อหน้าจอ
  const [name, setName] = useState(null);

  // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
  const [searchCriteria, setSearchCriteria] = useState({
    docDate: null,
    dateTo: null,
    docIsPickingList: null,
  });

  // ข้อมูลที่แสดงรายงาน
  const [filteredData, setFilteredData] = useState([]);

  // สำหรับ Table รายงาน
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const [soDataList, setSoDataList] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);
  const [formDetailList, setFormDetailList] = useState([]);
  const [carList, setCarList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryLineId, setDeliveryLineId] = useState(null);
  const [dlLineName, setDlLineName] = useState("");
  const [dlSelected, setDlSelected] = useState({ DL_Id: "" });
  const [arCodeFrom, setArCodeFrom] = useState("");
  const [arCodeTo, setArCodeTo] = useState("");
  const [exportController, setExportController] = useState({
    exportToExcel: null,
    isExporting: false,
    hasData: false,
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("6. รายงานลูกหนี้ รายวัน");
    setFilteredData([]);
    const dlDataList = await getDataWithComp("DL_Line_H", "ORDER By DL_Id ASC");
    if (dlDataList && dlDataList.length > 0) {
      setDlLineList(dlDataList);
    }
  };

  const resetValues = () => {
    setSearchCriteria({
      docDate: null,
      dateTo: null,
      docIsPickingList: null,
    });
    setDlSelected({ DL_Id: "" });
    setArCodeFrom("");
    setArCodeTo("");
    setFilteredData([]);
    setCurrentPage(1);
    setItemsPerPage(16);
    setCarList([]);
    setDriverList([]);
    setSoDataList([]);
  };

  const handleReset = async () => {
    resetValues();
    await initialize();
  };

  const onRowSelectDL = async (dlSelected) => {
    try {
      setIsLoading(true);
      setDlSelected(dlSelected);
      handleSoClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeDate = (value, name) => {
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleRadioChange = (e) => {
    const value = e.target.value === "" ? null : Number(e.target.value);
    setSearchCriteria((prev) => ({
      ...prev,
      docIsPickingList: value,
    }));
  };

  const fetchCarAndDriverList = async (dlId) => {
    let findCarList;

    if (dlId) {
      findCarList = await getDataWithComp("View_DL_Car", `AND DL_Id = ${dlId}`);
    } else {
      findCarList = await getDataWithComp("Tb_Set_Car", `AND Car_Status = 'Y'`);
    }

    if (findCarList && findCarList.length > 0) {
      setCarList(findCarList);
    } else {
      setCarList([]);
    }

    const findDriverList = await getDataWithComp(
      "Tb_Set_Employee",
      `AND Emp_Status = 'Y' AND Driver_Flag = 'Y'`,
    );
    if (findDriverList && findDriverList.length > 0) {
      setDriverList(findDriverList);
    } else {
      setDriverList([]);
    }
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);

      let date = "";
      if (searchCriteria.docDate && searchCriteria.dateTo) {
        date += ` AND (CAST(SOH.Doc_Date AS DATE) BETWEEN '${searchCriteria.docDate}' AND '${searchCriteria.dateTo}')`;
      } else if (searchCriteria.docDate && !searchCriteria.dateTo) {
        date += ` AND CAST(SOH.Doc_Date AS DATE) = '${searchCriteria.docDate}'`;
      } else if (!searchCriteria.docDate && searchCriteria.dateTo) {
        getAlert("WARNING", "กรุณาระบุวันที่เอกสาร");
        return;
      }

      let code = "";
      if (arCodeFrom && arCodeTo) {
        code += ` AND (SOH.AR_Code BETWEEN '${arCodeFrom}' AND '${arCodeTo}')`;
      } else if (arCodeFrom && !arCodeTo) {
        code += ` AND SOH.AR_Code = '${arCodeFrom}'`;
      } else if (!arCodeFrom && arCodeTo) {
        getAlert("WARNING", "กรุณาระบุรหัสลูกหนี้");
        return;
      }

      let typeCondition = "";
      if (searchCriteria.docIsPickingList === 1) {
        typeCondition = ` AND SOH.Doc_Is_PickingList = 0`;
      } else if (searchCriteria.docIsPickingList === 2) {
        typeCondition = ` AND SOH.Doc_Is_PickingList <> 0`;
      }

      const response = await getDataWithJoin(
        `FORMAT(CAST(SOH.Doc_Date AS DATETIME), 'dd/MM/yyyy') AS Doc_Date,
         CASE WHEN SOH.Doc_Is_PickingList = 0 THEN 'S' ELSE 'V' END AS SO_Type,
         c.DL_LineName,
         SOH.Doc_No,
         SOH.AR_Code,
         SOH.AR_Name,
         SOH.NetTotal,
         SOH.Doc_ID,
         c.DL_Id`,
        `API_0701_SO_H AS SOH`,
        `LEFT JOIN API_0801_PKList_H AS PK ON (SOH.Doc_Is_PickingList = PK.Doc_Id)
         LEFT JOIN DL_Line_H AS c ON (PK.Delivery_Line_Id = c.DL_Id)
         WHERE SOH.Doc_Status_Paid = 2 AND ISNULL(SOH.Doc_Status, 0) <> 13
         AND SOH.Comp_Id = ${window.localStorage.getItem("company")}
         ${date}
         ${code}
         ${typeCondition}
         ${dlSelected?.DL_Id ? `AND c.DL_Id = ${dlSelected?.DL_Id}` : ""}`,
        `GROUP BY
           SOH.Doc_ID,
           SOH.Doc_Date,
           SOH.Doc_No,
           SOH.AR_Code,
           SOH.AR_Name,
           SOH.NetTotal,
           c.DL_LineName,
           c.DL_Id,
           SOH.Doc_Is_PickingList
         ORDER BY SOH.Doc_Date, SOH.Doc_No ASC`,
      );

      if (response && response.length > 0) {
        setFilteredData(response);
      } else {
        setFilteredData([]);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  const handleExportReady = useCallback((state) => {
    setExportController((prev) => {
      if (
        prev.exportToExcel === state.exportToExcel &&
        prev.isExporting === state.isExporting &&
        prev.hasData === state.hasData
      ) {
        return prev;
      }
      return state;
    });
  }, []);

  const handleExportClick = useCallback(() => {
    if (exportController?.exportToExcel) {
      exportController.exportToExcel();
    } else {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
    }
  }, [exportController]);

  // Calculate total NetTotal for summary row
  const totalNetTotal = filteredData.reduce(
    (sum, item) => sum + (parseFloat(item.NetTotal) || 0),
    0,
  );

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/receivables-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="row align-items-end">
                      <div className="col-md-3">
                        <label htmlFor="docDate" className="form-label">
                          วันที่เอกสาร
                        </label>
                        <DatePicker
                          label=""
                          name="docDate"
                          value={searchCriteria.docDate}
                          onChange={(date) => handleChangeDate(date, "docDate")}
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="dateTo" className="form-label">
                          ถึง
                        </label>
                        <DatePicker
                          label=""
                          name="dateTo"
                          value={searchCriteria.dateTo}
                          onChange={(date) => handleChangeDate(date, "dateTo")}
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">รหัสลูกหนี้</label>
                        <input
                          type="text"
                          className="form-control"
                          value={arCodeFrom}
                          onChange={(e) => setArCodeFrom(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">ถึง</label>
                        <input
                          type="text"
                          className="form-control"
                          value={arCodeTo}
                          onChange={(e) => setArCodeTo(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3 mt-3">
                        <label className="form-label">สายรถ</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-spacing"
                            name="apCode"
                            value={dlSelected?.DL_LineName || ""}
                            disabled={true}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSoShow();
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">ประเภท</label>
                        <div className="mt-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="docIsPickingList"
                              id="typeAll"
                              value=""
                              checked={searchCriteria.docIsPickingList === null}
                              onChange={handleRadioChange}
                            />
                            <label
                              className="form-check-label w-25"
                              htmlFor="typeAll"
                            >
                              ทั้งหมด
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="docIsPickingList"
                              id="typeAdmin"
                              value="1"
                              checked={searchCriteria.docIsPickingList === 1}
                              onChange={handleRadioChange}
                            />
                            <label
                              className="form-check-label w-25"
                              htmlFor="typeAdmin"
                            >
                              Admin
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="docIsPickingList"
                              id="typeVansale"
                              value="2"
                              checked={searchCriteria.docIsPickingList === 2}
                              onChange={handleRadioChange}
                            />
                            <label
                              className="form-check-label w-25"
                              htmlFor="typeVansale"
                            >
                              Vansale
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3 d-flex justify-content-end align-items-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            marginRight: "20px",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            marginRight: "20px",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={handleExportClick}
                          disabled={
                            !exportController.hasData ||
                            exportController.isExporting
                          }
                        >
                          <i className="fas fa-file-excel" />{" "}
                          {exportController.isExporting
                            ? "กำลังส่งออก..."
                            : "Export"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => resetValues()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DeliveryModalS
                showSoModal={showSoModal}
                handleSoClose={handleSoClose}
                soDataList={soDataList}
                dlLineList={dlLineList}
                onRowSelectDL={onRowSelectDL}
              />
              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                setCurrentPage={setCurrentPage}
                fieldMappings={{
                  docDate: "Doc_Date",
                  soType: "SO_Type",
                  dlLineName: "DL_LineName",
                  docNo: "Doc_No",
                  arCode: "AR_Code",
                  arName: "AR_Name",
                  netTotal: "NetTotal",
                }}
                onExportReady={handleExportReady}
                showExportButton={false}
              />
              {filteredData.length > 0 && (
                <div className="col-md-12 mt-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-end">
                        <strong className="me-3">ยอดรวมจำนวนเงิน:</strong>
                        <span>{formatCurrency(totalNetTotal)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceivablesReport;
